export default {
  setServiceArea(state, data) {
    state.serviceArea = data;
  },

  setAreaPoints(state, data) {
    state.areaPoints = data;
  }
};
